module.exports = __webpack_public_path__ + "img/OverseaMember01.cdde3f8c.jpg";